import { Skeleton } from '@chakra-ui/react';

export const MapEntryPointSkeleton = () => <Skeleton height="154px" mb={5} />;
